import { createSlice } from "@reduxjs/toolkit";
import { AdministrationSliceState } from "./administration-interface";
import { fetchDataSources } from "./administration-async-calls";

const initialState: AdministrationSliceState = {
  dataSources: [],
  isDataSourceFetching: false,
  isLogoEnabled: true,
};

const administrationSlice = createSlice({
  name: "administration",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDataSources.pending, (state) => {
        state.dataSources = [];
        state.isDataSourceFetching = true;
      })
      .addCase(fetchDataSources.fulfilled, (state, action) => {
        state.dataSources = action.payload;
        state.isDataSourceFetching = false;
      })
      .addCase(fetchDataSources.rejected, (state) => {
        state.dataSources = [];
        state.isDataSourceFetching = false;
      });
  },
});

export const {} = administrationSlice.actions;

export default administrationSlice.reducer;
